import { render, staticRenderFns } from "./PretrainingLessonQuiz.vue?vue&type=template&id=1d8966e4&"
import script from "./PretrainingLessonQuiz.vue?vue&type=script&lang=js&"
export * from "./PretrainingLessonQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports